module.exports = __webpack_public_path__ + "static/media/blogImage1.8233d2c0.jpg";